import * as React from 'react';
import { useBOMStore } from 'src/hooks/bom';
import useReduxState from 'src/hooks/useReduxState';
import Common from '../../Common';
import { useSearchParams } from 'react-router-dom';
import { isObject } from "underscore";
import { SET_bomMultipleMatchTrigger } from 'src/store/slice/model/BOM';
import store from 'src/storeWire';
import { remove_selected_field } from "src/store/slice/model/BOM/BOMExactMatch";
import System from 'src/helper/system';
import Helper from 'src/support/Helper';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useBOMProjectStore } from "src/hooks/bom_project";
import { useProductInventoryStore } from 'src/hooks/productInventory';
import { useProductPricingStore } from 'src/hooks/productPricing';

const BomRemovePart = (props) => {
    const { bomId, bomDetailId, singleBomDetail, exact_match, removeType, removePartNumber } = props

    const [{ bom_detail_by_bom_id,bom_detail_by_bom_id_type,bom_health_by_bom_id, bomSortByUpdatedDate }, { get_bom_detail_by_bom_id_with_type, get_bom_health_by_bom_id, get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui }, {remove_part_number }] = useBOMStore();
    const [searchParams] = useSearchParams();
    const [BomTabList__Component__Loader] = useReduxState(searchParams.get(Common.param_key_BomTabList) ? searchParams.get(Common.param_key_BomTabList) : Common.default_component_BomTabList.param_value, Common.redux_key_BomTabList, 'BomTabList__Component__Loader');
    const [top] = useReduxState({}, 'BOM_DETAIL_TOP_PARAM_FOP_LIMIT', true);
    const [{ bom_project_list }, { }, { }] = useBOMProjectStore();
    const [, { get_inventory_by_id }, { }] = useProductInventoryStore();
    const [{ pricingList }, { }, { }] = useProductPricingStore();

    const onRemovePart = async (bomDetailId, bomId) => {
        let params = {}
        params.bomDetailId = bomDetailId
        params.bomId = bomId

        let removePartRes = await remove_part_number(params)
        if (removePartRes !== undefined &&
            removePartRes.payload.data !== undefined) {

            let top_here = 10;
            if (top[Common.chain_BomTabList[BomTabList__Component__Loader].api_fetch_type] !== undefined &&
                top[Common.chain_BomTabList[BomTabList__Component__Loader].api_fetch_type].top
            ) {
                top_here = top[Common.chain_BomTabList[BomTabList__Component__Loader].api_fetch_type].top;
            }
            top_here = top_here === 10 ? 20 : (top_here - 1);

            let param = {
                bomId: bomId,
                matchType: Common.chain_BomTabList[BomTabList__Component__Loader].api_fetch_type,
                top: top_here,
                skip: 0
            }

            if (bomSortByUpdatedDate) {
                param.sortColumn = "updated_date"
                param.sortOrder = "desc"
            }

            if(removeType){
                removeMatchesEvent(removeType);
            }

            await get_bom_detail_by_bom_id_with_type(param);

            store.dispatch(remove_selected_field({
                bomDetailId: bomDetailId
            }));

            if (exact_match) {
                System.alert(`Part <b> ${Helper.valueIsNotNull(singleBomDetail.manufacturerPartNumber) ? singleBomDetail.manufacturerPartNumber : singleBomDetail.partNumberRaw} </b> has been deleted from the BOM`, 'success')
            }
            if (bom_health_by_bom_id !== undefined && isObject(bom_health_by_bom_id) && Object.entries(bom_health_by_bom_id).length > 0 && singleBomDetail !== undefined && singleBomDetail.product !== undefined && singleBomDetail.product.LifeCycleRisk.trim()) {
                await get_bom_health_by_bom_id({ bomId: bomId })
            }
            store.dispatch(SET_bomMultipleMatchTrigger({
                BOMTriggerVal: 'BOM_EXACT_TRIGGER'
            }));
        }
    }

    function removeMatchesEvent(removeType){
        let eventType ;
        if(removeType ===  "exactMatches") {
            eventType = "bomProductRemoval";
        }
        else if(removeType ===  "multipleMatches") {
            eventType = "bomProdRemoveMultipleResolved";
        }
        else if(removeType ===  "noMatches") {
            eventType = "bomProdRemoveNoMatchesResolved";
        }
        localStorage.setItem("adobeEventType",eventType);
        let bomDetails = {
            bomId:bom_detail_by_bom_id.bomId,
            bomName :bom_detail_by_bom_id.bomName,
            newBOM: bom_detail_by_bom_id.newBOM,
            source: bom_detail_by_bom_id.source,
            exactMatchCount: bom_detail_by_bom_id_type?.Exact?.count,
            nomatchCount: bom_detail_by_bom_id_type?.NoMatch?.count,
            multipleMatchCount: bom_detail_by_bom_id_type?.Multiple?.count,
            
          };
          if(bom_project_list){
            bomDetails.projectName = bom_project_list[bom_detail_by_bom_id.projectId]?.projectName
          }
        let partNumber = removePartNumber;
        if(removeType === "exactMatches"){
            let prodDetails = {...singleBomDetail?.product};
            prodDetails.qas = getInventory(prodDetails?.ERPPartNumber)?.qas;
            let pricingDetails = getPricing(
                prodDetails.ERPMFRPartNumber || prodDetails.erpMfrPartNumber,
                prodDetails.ERPPartNumber,
                prodDetails.ERPPartNumberModified
              )[0];
            prodDetails.priceSource = pricingDetails?.priceSource;
            prodDetails.subtotal = pricingDetails?.marketPrice ? pricingDetails.marketPrice * 1000 : 0;
              
            if(Object.keys(bomDetails).length) {
                HelperAdobeEvent.trackingAdobeEvent({bomDetails,prodDetails});
            }
        }
        else {
            if(Object.keys(bomDetails).length) {
                HelperAdobeEvent.trackingAdobeEvent({bomDetails,partNumber});
            }
        }
        


    }

    const getInventory = (ERPPartNumber) => {
        return get_inventory_by_id(ERPPartNumber)
    };

      const getPricing = (
        ERPMFRPartNumber,
        ERPPartNumber,
        ERPPartNumberModified
      ) => {
        ERPPartNumber = ERPPartNumberModified ? "" : ERPPartNumber;
        if (pricingList[ERPMFRPartNumber + "-" + ERPPartNumber]) {
          return pricingList[ERPMFRPartNumber + "-" + ERPPartNumber];
        }
        return [];
      };
      
      
      
      

    return (
        <>
            <i className="fa fa-trash font-16 ms-2 cursor-pointer text-black-stone"
                onClick={() => onRemovePart(bomDetailId, bomId)}></i>
        </>
    );
}

export default BomRemovePart;